import type { ReactNode } from 'react';
import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/app/authStore';

interface Props {
  permission: string;
  children: ReactNode;
}

/** Route-level guard; the server enforces the same rule on every call the page makes. */
export default function RequirePermission({ permission, children }: Props) {
  const { t } = useTranslation();
  const can = useAuthStore((state) => state.can);

  if (!can(permission)) {
    return (
      <Box className="p-6">
        <Alert severity="warning">{t('errors.forbidden')}</Alert>
      </Box>
    );
  }
  return <>{children}</>;
}
